import {
  MainPermission,
  Permission,
  Rol,
} from '../interfaces/permision.interface';
import { PermissionLookup } from '../interfaces/permission-lookup.interface';

export type PermissionRequirement = number | string;

function normalizePermissionName(permissionName: string): string {
  return permissionName.trim();
}

export function buildPermissionLookup(
  mainPermissions: MainPermission[] = [],
): PermissionLookup {
  const subPermissions = mainPermissions.flatMap(
    (permission) => permission.permisos ?? [],
  ) as Permission[];

  return {
    mainPermissionIds: new Set(
      mainPermissions.map((permission) => permission.id),
    ),
    subPermissionIds: new Set(subPermissions.map((permission) => permission.id)),
    mainPermissionNames: new Set(
      mainPermissions.map((permission) =>
        normalizePermissionName(permission.nombre_permiso),
      ),
    ),
    subPermissionNames: new Set(
      subPermissions.map((permission) =>
        normalizePermissionName(permission.nombre_permiso),
      ),
    ),
  };
}

export function hasAnyPermission(
  lookup: PermissionLookup,
  permissions: PermissionRequirement[],
): boolean {
  return permissions.some((permission) => {
    if (typeof permission === 'number') {
      return (
        lookup.mainPermissionIds.has(permission) ||
        lookup.subPermissionIds.has(permission)
      );
    }

    const normalizedPermission = normalizePermissionName(permission);
    return (
      lookup.mainPermissionNames.has(normalizedPermission) ||
      lookup.subPermissionNames.has(normalizedPermission)
    );
  });
}

export function hasPermissionFromRole(
  role: Rol | null | undefined,
  requirement:
    | PermissionRequirement
    | PermissionRequirement[]
    | null
    | undefined,
): boolean {
  if (!role || !requirement) {
    return false;
  }

  const permissions = Array.isArray(requirement)
    ? requirement
    : [requirement];

  return hasAnyPermission(
    buildPermissionLookup(role.permisos_principales ?? []),
    permissions,
  );
}
